import { Box, IconButton, SwipeableDrawer, useMediaQuery, useTheme } from '@mui/material';
import { Close } from '@mui/icons-material';
import { FC, useState } from 'react';

import { Configs } from './Configs';
import { Profile } from './Profile';
import { Auth } from '../../../auth/components/Auth';
import { UserNotificationTriggersModal } from '../../../user-notification-triggers';

interface UserMenuProps {
  open: boolean;
  toggle: () => void;
}

export const UserMenu: FC<UserMenuProps> = ({ open, toggle }) => {
  const theme = useTheme();
  const isMedium = useMediaQuery(theme.breakpoints.up('md'));
  const [notificationModalOpen, setNotificationModalOpen] = useState(false);

  const handleOpenNotificationModal = () => {
    setNotificationModalOpen(true);
  };

  const handleCloseNotificationModal = () => {
    setNotificationModalOpen(false);
  };

  return (
    <>
      <SwipeableDrawer anchor="right" open={open} onClose={toggle} onOpen={toggle}>
        {!isMedium && (
          <Box padding={theme.spacing(1, 3)} display={'flex'} alignItems={'center'} justifyContent={'flex-end'}>
            <IconButton size="medium" onClick={toggle}>
              <Close fontSize="medium" />
            </IconButton>
          </Box>
        )}
        <Box sx={{ minWidth: 320 }} padding={theme.spacing(6, 3)}>
          <Auth />
          <Profile />
          <Configs onOpenNotifications={handleOpenNotificationModal} />
        </Box>
      </SwipeableDrawer>
      
      <UserNotificationTriggersModal 
        open={notificationModalOpen} 
        onClose={handleCloseNotificationModal} 
      />
    </>
  );
};
